import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';

export const Content = styled(ListContainer)`
    @media (max-width: ${wideBreakpoints.mobile}) {
        align-items: center;
    }
`;

export const Icon = styled(BlockContainer)`
    flex: 0 0 40px;
    width: 40px;
    height: 40px;

    img,
    picture {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: contain;
    }
`;
